"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogCarouselView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const components_1 = require("./components");
function BlogCarouselView({ articles, infoNode, allText = 'ALL FROM BLOG', }) {
    const isMobile = (0, app_1.useIsMobile)(1024);
    const articlePath = (0, app_1.useContextPath)('article');
    const remToPx = (0, app_1.useRemToPx)();
    return ((0, jsx_runtime_1.jsx)(components_1.Wrap, { children: (0, jsx_runtime_1.jsxs)(components_1.WrapInner, { children: [infoNode !== null && infoNode !== void 0 ? infoNode : ((0, jsx_runtime_1.jsx)(components_1.InfoStack, { children: typeof allText === 'string' ? ((0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: articlePath }, { children: (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: allText })) }))) : (allText) })), (0, jsx_runtime_1.jsx)(ui_1.CarouselKeen, { data: articles, plugins: [
                        ({ slides, update }) => {
                            slides.forEach((slide) => {
                                slide.style.minWidth = isMobile ? '20rem' : '40rem';
                                slide.style.maxWidth = isMobile ? '20rem' : '40rem';
                            });
                            update();
                        },
                    ], render: (data) => ((0, jsx_runtime_1.jsx)(app_1.AssetsProvider, Object.assign({ path: `/article/${data.id}` }, { children: (0, jsx_runtime_1.jsx)(components_1.FullWidthLink, Object.assign({ href: `${articlePath}/${data.slug}` }, { children: (0, jsx_runtime_1.jsxs)(components_1.ItemStack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(components_1.ArticleImage, { children: (0, jsx_runtime_1.jsx)(app_1.Image, { img: data.image }) }), (0, jsx_runtime_1.jsx)(app_1.Text, { children: data.category.title }), (0, jsx_runtime_1.jsx)(components_1.Title, Object.assign({ as: "h5" }, { children: data.title }))] })) })) }))), hideArrows: true, options: {
                        breakpoints: {
                            [app_1.notDesktop]: {
                                slides: {
                                    perView: 1,
                                    spacing: 15,
                                },
                            },
                            [app_1.desktop]: {
                                slides: {
                                    perView: 'auto',
                                    spacing: remToPx(1.25),
                                },
                            },
                        },
                    } })] }) }));
}
exports.BlogCarouselView = BlogCarouselView;
